import {useSearchParams} from "next/navigation";

export const CallbackUrlInput = () => {
  const searchParams = useSearchParams();
  const callbackUrl = searchParams.get("callbackUrl");

  return <input name="callbackUrl" type="hidden" value={callbackUrl ?? ""} />;
};
